const state = {}

const getters = {
  menu(state, getters, rootState, rootGetters) {
    const menuItems = [{
      title: 'Dashboard',
      path: '/dashboard',
      svg: 'menu/dashboard',
      menu: 'dashboard',
    }]

    if (rootGetters['me/canReadProvider']) {
      const canSearchProvider = rootGetters['me/canSearchProvider']
      const isSuperAdmin = rootGetters['me/isSuperAdmin']
      const providerId = rootGetters['me/providerId']

      if (canSearchProvider && isSuperAdmin) {
        menuItems.push({
          title: 'Providers',
          path: '/providers',
          svg: 'menu/retailers',
          menu: 'providers',
        })
      } else if (providerId) {
        menuItems.push({
          title: 'Provider',
          path: '/provider',
          svg: 'menu/retailers',
          menu: 'provider',
        })

        if (rootGetters['me/canReadApiKey']) {
          menuItems.push({
            title: 'API Keys',
            path: '/api-keys',
            svg: 'menu/unlock',
            menu: 'api-keys',
          })
        }
      }
    }

    if (rootGetters['me/canReadRetailer']) {
      menuItems.push({
        title: 'Retailers',
        path: '/retailers',
        svg: 'menu/retailers',
        menu: 'retailers',
      })
    }

    if (rootGetters['me/canReadOffer']) {
      menuItems.push(
        ...[
          {
            title: 'Offers',
            path: '/offers',
            svg: 'menu/offers',
            menu: 'offers',
          },
          {
            title: 'Offer Groups',
            path: '/offer-groups',
            svg: 'menu/offers',
            menu: 'offer-groups',
          },
        ])
    }

    if (rootGetters['me/canReadCategory']) {
      menuItems.push({
        title: 'Categories',
        path: '/categories',
        svg: 'menu/categories',
        menu: 'categories',
      })
    }

    menuItems.push({
      title: 'Log',
      path: '/log',
      svg: 'menu/log',
      menu: 'log',
    })

    return menuItems
  },
}

const mutations = {}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
